import { Tag } from "antd";
import React, { useEffect, useState } from "react";
import { RenderProps } from "../DynamicColumn";

export default (props: RenderProps) => {
  const [sources, setSources] = useState([]);

  useEffect(() => {
    props.item.sources.query().find().then(setSources);
  }, []);

  const sourceTags = sources.map((source) => (
    <Tag key={source.id}>{source.get("name")}</Tag>
  ));

  return <>{sourceTags}</>;
};
